export default {
  otherDocDetail: {
    viewClient: 'CLIENT VIEW',
    viewStaff: 'STAFF VIEW',
    copyLmdx: 'COPY LMDX',
    downloadCropped: 'DOWNLOAD CROPPED',
    runningInfo: 'Running info:',
    errors: 'Errors:'
  },
  ViesValidator: {
    documents: "Documents",
    upload_documents: "Upload documents",
    actions: "ACTIONS",
    add_filter: "add filter",
    delete_documents: "Delete documents",
    continue_workflow: "Retry",
    restart_workflow: "Restart",
    refresh: "Refresh",
    download_documets: "Download documents",
    download:"Download",
    change_workflow: "Change Workflow",
    relaunch_workflow: "Relaunch Workflow",
    move_to_a_folder: "Move to a folder",

    warning_delete: "The selected documents will be deleted.",
    warning_delete_2: "Are you sure?",
    checkbox_text: "Delete associated records",
    cancel: "Cancel",
    delete: "Delete",

    modify_workflow: "Modify workflow",
    change: "Change",

    select_folder_tooltip: "Select folder",
    select_folder: "Select the destination folder",
    create_folder: "Create folder",
    hide_my_unit: "Hide My unit",
    create: "Create",
    accept: "Accept",
    folder_name: "Folder name",
    privacy_label: "Mark as private",

    delete_folder: "Delete folder",
    warning_delete_folder: "Are you sure you want to delete the selected folder?",
    delete_folder_only: "Delete folder only (keep contents)",
    delete_folder_recursively: "Delete folder and all its contents",
    delete: "Delete",

    edit_folder: "Edit folder",
    name_folder: "Folder name",
    edit: "Edit",

    id: "Id",
    document_name: "Document name",
    document_type: "Document type",
    upload_data: "Upload date",
    workflow: "Workflow",
    state: "State",
    folder_path: "Path",
    search_all_documents: "Search in all documents...",
    search_results_global: "Results for \"{term}\" in all folders ({count} documents)",

    payroll: "Payroll",
    contract: "Contract",
    model_tax: "Models/Taxes",
    certificate: "Certificate",
    bill: "Invoice",
    other: "Others",
    pending: "Pending",
    waiting_approval: "Pending approval",
    waiting: "Waiting",
    approved: "Approved",
    rejected: "Rejected",
    insufficient_credits: "Insufficient balance",
    lost_workflow: "Workflow error - missing",
    no_workflow: "No workflow",
    error: "Error",
    done: "Completed",
    WaitForApproval: "Wait for approval",
    AskAI: "Information extraction with AI",
    AddDocumentRepresentationToConversation: "Add document representation to conversation",
    CompleteConversation: "Complete conversation with AI",
    UploadAsInvoice: "Upload as invoice",
    SendThroughEmail: "Send via email",
    SendEmailWithTemplate: "Send email with template",
    LookupAndMatchInstance: "Search and attach record",
    LookupAndMatchMultipleInstances: "Search and attach multiple records",
    ExtractInstanceFromRawData: "Extract previously injected record",
    CreateInstanceFromContext: "Create record from context",
    CreateInstance: "Create record",
    CreateInstancesFromList: "Create records from list",
    AddInstanceToList: "Add record to list",
    ModifyContext: "Modify record",
    DeleteContextInstance: "Delete record",
    PayrollAccounting: "Post payroll",
    SendDataToEndpoint: "Send data to endpoint",
    NotifyCounterpart: "Notify counterpart",
    RunCommand: "Run command",
    RunQuery: "Run query",
    RunWorkflow: "Run workflow",
    RunScript: "Run Python script",
    SplitFile: "Split file pages",
    ExtractTextFromDocument: "Extract text from document",

    docs_per_page: "Documents per page",
    of: "of",

    "not_same_wf":"All selected documents must have the same workflow",

    my_unit: "My unit",
    new: "New",

    label_name: "Name",
    label_type: "Type",
    label_date_from: "Data from",
    label_date_to: "Data to",
    label_pending_my_approval: "Pending my approval",

    filters: "Filters",
    type_of_document: "Type of doc",
    date: "Date",
  },
  AddFilterDocuments: {
    add_filter: "Add filter",
    see_invoices: "See invoices",
  },
  PDFDocumentV2: {
    invoice_detail: "Invoice details",
    doc_detail: "Document details",
    upload_invoice: "Upload invoice",
  },
  GeneralWorkflowDetail: {
    continue_workflow: "Retry",
    state: 'State',

    pending: "Pending",
    waiting_approval: "Pending approval",
    approved: "Approved",
    rejected: "Rejected",
    insufficient_credits: "Insufficient balance",
    lost_workflow: "Workflow error - missing",
    error: "Error",
    done: "Completed",
    WaitForApproval: "Wait for approval",
  },
  AppSearchAddFilterBtn: {
    add_filter: 'Add filter',
    delete_filters: 'Delete filters',
    filter: "Filter",
  },
  AppSearchFilterChip: {
    value: "Value",
    payroll: "Payroll",
    contract: "Contract",
    taxes_and_models: "Models/Taxes",
    certificate: "Certificate",
    invoices: "Invoices",
    others: "Others",
    all: "All",
    yes: "Yes",
    no: "No",
    no_options_available: "No options available",
  },
  OtherDocWorkflowDetail: {
    staff_view: 'STAFF VIEW',
    client_view: 'CLIENT VIEW',

    copy_lmdx: 'COPY LMDX',
    download_cropped: 'DOWNLOAD CROPPED',
  },
  CommentSectionComponent: {
    no_comments: "No comments",
    write_your_comment: "Write your comment...",
  },
  ExtractedDataComponent: {
    extracted_information: "Extracted information",
  },
  GenericDocumentLoader: {
    upload_documents: "Upload documents",
    title_upload_docs: "From here you can upload all your documents",
    subtitle: "It can be in pdf/jpg/png",
    drag_files: "Drag your files here or click to select files from a folder",
    document_type: "Document type",
    invoice_type: "Invoice type",

    add_type: "Add type",
    edit_workflows: "Edit workflows",

    my_unit: "My unit",
    select_location: "Select location",
    select_folder: "Select the destination folder",
    cancel: "Cancel",
    accept: "Accept",

    payroll: "Payroll",
    contract: "Contract",
    taxes_and_models: "Models/Taxes",
    certificate: "Certificate",
    invoices: "Invoices",
    others: "Others",
    add_type: "Add type",

    out_invoice: 'Customer invoice',
    in_invoice: 'Supplier invoice',

    types_of_documents: "Types of documents",
    name: "Name",
    close: "Close",
    save: "Save",

    no_workflow: "No workflow",

    drag_files_mobile: "Drag your documents here",
  },
  WorkflowList: {
    refresh: "Refresh",
  },
  SelectorEmpresa: {
    company: "Company",
  },
  App: {
    invoices: "Accounting",
    suppliers: "Suppliers",
    customers: "Customers",
    banks: "Banks",
    electronic_invoice: "Electronic Invoice",
    gestor_ia: "Gestor IA",
    invoice_approval: "Invoice approval",
    documents: "Documents",
    my_records: "My Records",
    remesas: "Remittances",
    payrolls: "Payrolls",
    dashboard: "Dashboard",
    clock_in: "Working Hours",
    tickets: "Tickets",
    persons: "Persons",
    settings: "Settings",
    trash: "Trash",    

    my_companies: "My Companies",
    manager_summary: "Manager Summary Table",
    accounting_summary: "Accounting Summary Table",
    configuration: "Configuration",
    my_data: "My Data",
    my_expenses: "My Expenses",
    guidelines: "Guidelines",
    functionalities: "Functionalities",
    kpis: "KPIs",
    access_log: "Access Log",
    backup_log: "Backup Log",
    network_drives: "Network Drives",
    whats_new: "What's New",
    log_out: "Log out",
    tariffs_management: "Tariffs management",
    client_tariff: "Client tariff",
    users: "Users",
    locations: "Locations",
    bank_summary: "Bank Summary Table",
    onboard_info: "Onboard Info",
    download_client: "Download Client",
    reports: "Reports",
    contracts_kpis: "Contracts KPIs",
    supplier_prompts_ai: "Supplier Prompts AI"
  },
  UserConfiguration: {
    header: "User Configuration",
    title1: "Configure your user account to get the most out of Inmatic",
    title2: "Configure your user to get the most out of the program",
    body: "Here you can find self-managed options to configure your user."
  },
  ListObject: {
    companies: "Companies",
    configuring: "Configuring...",
    per_page: "per page",
    of: "of",

    id: "Id",
    company_name: "Company name",
    company_cif: "Company CIF",
    route: "Route",
    state: "Status",
    type: "Type",
  },
  ConnectorList:{
    companies: "Companies",
  },
  PopupCreateCompany: {
    create_companies: "Create a Company",
    edit_company: "Edit company",
    company_name: "Company name",
    company_cif: "Company CIF",
    cancel: "Cancel",
    edit: "Edit",
    create: "Create",
    save: "Save",
  },
  ItemFilterDocuments: {
    name: "Name",
    type: "Type",
    date_from: "Date from",
    date_to: "Date to",
    pending_my_approval: "Pending my approval",

    payroll: "Payroll",
    contract: "Contract",
    taxes_and_models: "Models/Taxes",
    certificate: "Certificate",
    invoices: "Invoices",
    others: "Others",
    all: "All",

    yes: "Yes",
    no: "No",
  },
  Connector2List: {
    create_company: "Create company",
    refresh: "Refresh",
    companies: "Companies",
    id: "Id",
    name: "Name",
    cif: "CIF"
  },
  narcisTest:{
    'title': "Narci's test",
  }
}
